import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { Table, Card, CardBody, Modal, ModalHeader, ModalBody, Row, Col, Container, FormGroup, Label, Input } from "reactstrap";
import { AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation";
import ReactDrawer from "react-drawer";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { motion, AnimatePresence } from "framer-motion";
import Breadcrumbs from "../../components/Breadcrumb";
import { MainContent } from "../../components/Table/MainContent";
import { ActionRow } from "../../components/Table/ActionRow";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import BootstrapTable from "react-bootstrap-table-next";
import { showToast } from "../../components/Toast";
// import { FilterForm } from './FilterForm';
// import { BtnModal } from '../../components/Table/BtnModal';
// import { Search } from 'react-bootstrap-table2-toolkit';

import { notificationsApi } from "../../services/NotificationsService";

import bitrix from "../../assets/images/bitrix24.png";

const animatedComponents = makeAnimated();

export const Notification = ({ compData, keyWord, module }) => {
  const profileData = JSON.parse(localStorage.getItem("authUser"));
  const {
    data = [],
    isLoading,
    isFetching,
    // error,
    refetch,
  } = notificationsApi.useFetchAllNotificationsQuery(module, {
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
  });

  const [addNotification] = notificationsApi.useAddNotificationMutation();
  const [updateNotification] = notificationsApi.useUpdateNotificationMutation();

  const [modalNotification, setModalNotification] = useState(false);
  const toggleNotificationModal = () => setModalNotification(!modalNotification);

  const [position, setPosition] = useState("right");
  const [openDr, setOpenDr] = useState(false);

  const [users, setUsersData] = useState([]);
  const [departments, setDepartmentsData] = useState([]);
  const [notifications, setNotificationsData] = useState([]);
  const [notification, setSelNotification] = useState([]);

  useEffect(() => {
    const notifs = Array.isArray(data?.notifications) ? data.notifications : [];
    const deps = Array.isArray(data?.departments) ? data.departments : [];
    const usrs = Array.isArray(data?.users) ? data.users : [];

    setNotificationsData((prev) => (JSON.stringify(prev) !== JSON.stringify(notifs) ? [...notifs] : prev));
    setDepartmentsData((prev) => (JSON.stringify(prev) !== JSON.stringify(deps) ? [...deps] : prev));
    setUsersData((prev) => (JSON.stringify(prev) !== JSON.stringify(usrs) ? [...usrs] : prev));
  }, [data?.notifications]);
  /**
   * Toggles the visibility of the right drawer.
   * Sets the drawer position to 'right' and switches its open/closed state.
   */
  const toggleRightDrawer = () => {
    setPosition("right");
    setOpenDr((prev) => !prev);
  };
  /**
   * Closes the drawer by setting its open state to false.
   * Typically used as an event handler for closing UI drawers or side panels.
   */
  const onDrawerClose = () => setOpenDr(false);
  const openDrawerNotification = () => {
    // setSelectedProfile(user)
    toggleRightDrawer();
  };

  const [isEdit, setIsEdit] = useState(false);
  const [cardHeight, setCardHeight] = useState(0);
  const cardRef = useRef(null);
  useEffect(() => {
    if (!cardRef.current) return;
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const newHeight = entry.contentRect.height;
        if (newHeight > 0) setCardHeight(newHeight);
      }
    });
    resizeObserver.observe(cardRef.current);
    return () => resizeObserver.disconnect();
  }, []);

  /**
   * Handles the event when the "New Delivery" button is clicked.
   * Resets the delivery service, prepares the order data for a new delivery,
   * and ensures the copy mode is disabled.
   */
  const handleNewNotificationClick = () => {
    // setSelModule();
    setSelNotification();
    setIsEdit(false);
    sortUsersByDepartments();
    toggleNotificationModal();
  };
  const handleEditNotificationClick = (notification) => {
    sortUsersByDepartments();
    const selectedUsers = users.filter(
      (user) => notification.sendToPerson && notification.sendToPerson.includes(String(user.bitrixID)), // stringify because sendToPerson is ["369"]
    );

    setSelectedMulti(
      selectedUsers.map((user) => ({
        label: `${user.fname} ${user.sname}`,
        value: user.bitrixID, // or String(user.bitrixID) if your select expects strings
      })),
    );
    setSelNotification(notification);
    setIsEdit(true);
    toggleNotificationModal();
  };
  const [selectedMulti, setSelectedMulti] = useState(null);
  const handleMultiSelect = (selectedMulti) => {
    setSelectedMulti(selectedMulti);
  };
  const [userOptions, setUserOptions] = useState();
  const sortUsersByDepartments = () => {
    let userOptions = [];
    departments.map((department) => {
      userOptions.push({
        label: department.depName,
        options: [],
      });
      return userOptions;
    });
    for (var i = 0; i < userOptions.length; i++) {
      for (var j = 0; j < users.length; j++) {
        if (userOptions[i]["label"] === users[j]["department"]["depName"]) {
          userOptions[i]["options"].push({
            label: users[j]["fname"] + " " + users[j]["sname"],
            value: users[j]["bitrixID"],
          });
        }
      }
    }
    setUserOptions(userOptions);
  };
  const modules = ["Bot Helper Notification", "Bot Battlefield Notification", "Bot Priority Notification", "Bot Purchase Notification", "Bot Booking Meeting Notification"];
  const uniqueOptions = [...new Set((notifications ?? []).map((n) => n.option))];
  const groupChats = [
    { label: "MS Battlefield Notification", value: "chat10267" },
    { label: "MS Priority Orders notification", value: "chat10293" },
    { label: "Arrived Products  #7 Russia MOSCOW Safekeeping", value: "chat16143" },
    { label: "Arrived Products  #12 Poland, Wroclaw", value: "chat30921" },
  ];
  const isKeywordIncluded = (option, keyword) => {
    if (!option || !keyword) return false;
    return option.toLowerCase().includes(keyword.toLowerCase());
  };
  const modalNotificationContent = (
    <>
      <Row className="mb-3">
        <Col md={6}>
          <FormGroup className="mb-3">
            <AvField
              type="select"
              name="module"
              id="module"
              className="form-select"
              label="Module"
              errorMessage="Please Select Module"
              validate={{
                required: {
                  value: true,
                },
              }}
              // onChange={(e) => setNotificationService(e.target.value)}
              value={notification?.module || module}
            >
              <option value="">Choose</option>
              {modules.map((md) => (
                <option key={md} value={md}>
                  {md}
                </option>
              ))}
            </AvField>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup className="mb-3">
            <AvField name="option" label="Option" autoComplete="off" list="options" value={notification?.option || keyWord} />
            <datalist id="options">
              <optgroup label="Bank">
                {uniqueOptions.length &&
                  uniqueOptions.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
              </optgroup>
            </datalist>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-3">
            <Label htmlFor="sendToPerson">Send To Selected User</Label>
            <Select
              value={selectedMulti}
              isMulti={true}
              onChange={handleMultiSelect}
              options={userOptions}
              classNamePrefix="select2-selection"
              closeMenuOnSelect={false}
              components={animatedComponents}
              name="sendToPerson"
              id="sendToPerson"
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup className="mb-3">
            <AvField type="select" name="sendToChat" id="sendToChat" className="form-select" label="Send To Chat" value={notification?.sendToChat}>
              <option>Choose</option>
              {groupChats.map((chat, index) => (
                <option key={index} value={chat.value}>
                  {chat.label}
                </option>
              ))}
            </AvField>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup className="ms-5 mt-5">
            <AvCheckboxGroup name="sendDynamically">
              <AvCheckbox label="Send Message Based on User" className="mt-0 font-size-20" value="true" checked={notification?.sendDynamically} />
            </AvCheckboxGroup>
          </FormGroup>
        </Col>
      </Row>
      {/* <Row>
        <Col md={4}>
          <FormGroup className='mb-3'>
            <Label htmlFor='sendToPerson'>Send </Label>
            <Select
              value={selectedMulti}
              isMulti={true}
              onChange={handleMultiSelect}
              options={userOptions}
              classNamePrefix='select2-selection'
              closeMenuOnSelect={false}
              components={animatedComponents}
              name='sendToPerson'
              id='sendToPerson'
            />
          </FormGroup>
        </Col>
      </Row> */}
      <Row>
        <FormGroup className="mb-3">
          <AvField name="textMsg" label="Mesage" type="textarea" className="font-size-20" rows="6" autoComplete="off" value={notification?.textMsg} />
        </FormGroup>
      </Row>
      <Row></Row>
    </>
  );

  const handleNewNotificationSubmit = async (e, values) => {
    if (isEdit) {
      const updNotif = {
        _id: notification._id,
        module: values.module,
        option: values.option,
        sendToPerson: selectedMulti ? selectedMulti.map((item) => item.value) : null,
        sendToChat: values.sendToChat === "Choose" ? null : values.sendToChat,
        sendDynamically: values.sendDynamically.length > 0 ? true : false,
        textMsg: values.textMsg,
      };
      try {
        await updateNotification(updNotif).unwrap();
        toggleNotificationModal();
        showToast("Notification info is updated");
      } catch (error) {
        console.error("Failed to add new user:", error);
        showToast("Failed to update notification info", "error");
      }
    } else {
      const notifData = {
        module: values.module,
        option: values.option,
        sendToPerson: selectedMulti ? selectedMulti.map((item) => item.value) : null,
        sendToChat: values.sendToChat === "Choose" ? null : values.sendToChat,
        sendDynamically: values.sendDynamically.length > 0 ? true : false,
        textMsg: values.textMsg,
      };
      try {
        await addNotification(notifData).unwrap();
        toggleNotificationModal();
        showToast("New Notification is Added");
      } catch (error) {
        console.error("Failed to add new user:", error);
        showToast("Failed to Add New Notification", "error");
      }
    }
  };

  const parseNotificationText = (text) => {
    if (!text) return null;

    let parsed = text;

    // 1. Convert [b]text[/b] → <strong>text</strong>
    parsed = parsed.replace(/\[b\](.*?)\[\/b\]/g, "<strong>$1</strong>");

    // 2. Convert [URL=link]text[/URL] → <a href="link" target="_blank">text</a>
    parsed = parsed.replace(/\[URL=(.*?)\](.*?)\[\/URL\]/g, `<a href="$1" target="_blank" rel="noopener noreferrer">$2</a>`);

    // 3. Convert $variable → "variable"
    parsed = parsed.replace(/\$([a-zA-Z_]+)/g, '"$1"');

    // 4. Replace newlines with <br>
    parsed = parsed.replace(/\n/g, "<br/>");

    return parsed;
  };

  // const columns = [
  //   {
  //     text: "ID",
  //     dataField: "_id",
  //     sort: true,
  //     editable: false,
  //     formatter: (cell, row, rowIndex) => rowIndex + 1,
  //   },
  //   {
  //     text: "Message",
  //     dataField: "textMsg",
  //     csvExport: true,
  //     sort: true,
  //     editable: false,
  //     formatter: (cellContent, notification) => (
  //       <div className="">
  //         {/* <h5 className='font-size-16 mb-1'>
  //          {notification.textMsg}
  //         </h5> */}
  //         <h5
  //           className="font-size-16 mb-1 notification-text"
  //           dangerouslySetInnerHTML={{
  //             __html: parseNotificationText(notification.textMsg),
  //           }}
  //         />
  //       </div>
  //     ),
  //   },
  //   {
  //     text: "Send to",
  //     dataField: "sendToPerson",
  //     csvExport: true,
  //     sort: true,
  //     editable: false,
  //     formatter: (cellContent, notification) => (
  //       <div className="">
  //         <h5 className="font-size-16 mb-1">
  //           {users
  //             .filter((user) => notification.sendToPerson && notification.sendToPerson.includes(String(user.bitrixID)))
  //             .map((user) => `${user.fname} ${user.sname}`)
  //             .join(", ")}
  //         </h5>
  //         <h5 className="font-size-16 mb-1">{notification.sendDynamically ? "Send Directly to User" : ""}</h5>
  //         <h5 className="font-size-16 mb-1">{groupChats.find((chat) => chat.value === notification.sendToChat) ? groupChats.find((chat) => chat.value === notification.sendToChat).label : ""}</h5>
  //       </div>
  //     ),
  //   },
  //   {
  //     dataField: "menu",
  //     isDummyField: true,
  //     editable: false,
  //     text: "Action",
  //     formatter: (cellContent, notification) => (
  //       <div className="d-flex gap-3">
  //         <Link className="text-success" to="#">
  //           <i className="mdi mdi-pencil font-size-18" id="edittooltip" onClick={() => handleEditNotificationClick(notification)}></i>
  //         </Link>
  //       </div>
  //     ),
  //   },
  // ];

  // const defaultSorted = [
  //   {
  //     dataField: "date",
  //     order: "asc",
  //   },
  // ];

  const filteredNotifications = notifications.filter((n) => n.option?.toLowerCase().includes(keyWord.toLowerCase()));
  return (
    <>
      {profileData.result.accType === "Admin" && (
        <div className="notificationsComp d-inline">
          <img
            src={bitrix}
            alt="notification"
            style={{ width: 40, height: 40, cursor: "pointer" }}
            // onClick={toggleNotificationModal}
            onClick={() => openDrawerNotification()}
          />
          <ReactDrawer open={openDr} className="drawer-open" position={position} onClose={onDrawerClose}>
            <React.Fragment>
              {/* <PageLoader progress={progress} step={step} visible={visible} /> */}
              <div className="page-content" style={{ paddingTop: "40px" }}>
                <Container fluid>
                  <Breadcrumbs title="Notifications List" breadcrumbItem="Notifications List" />
                  <Row className="">
                    <Col lg="12">
                    <Card>
                      <CardBody className="cardBodySticky">

                  <ActionRow
                    page={{page: "notifications", showBtn: true}}
                    
                    // notificationSettings={notificationSettings}
                    // processedData={virtualTableData}
                    // isBootstrap={isBootstrap}
                    // myOrdersOptions={myOrdersOptions}
                    // searchOptions={{ searchText, handleSearch }}
                    // handleExportCSV={handleExportCSV}
                    // filterOptions={filterOptions}
                    // filterDbOptions={filterDbOptions}
                    // setNoDbFilters={setNoDbFilters}
                    btnCrtModalOptions={{                                                  btnLabelCrt: "New Notification Message",
                                                  modalSize: "xl",
                                                  modalTitle: isEdit ? "Edit Notification" : "Add Notification",
                                                  modalBtnLabel: isEdit ? "Edit Notification" : "Add Notification",
                                                  modalAdd: modalNotification,
                                                  toggleAddModal: toggleNotificationModal,
                                                  handleNewClick: handleNewNotificationClick,
                                                  modalContent: modalNotificationContent,
                                                  handleSubmit: handleNewNotificationSubmit}}
                    // btnCrtScndModalOptions={btnCrtScndModalOptions}
                    // btnCrtThrdModalOptions={btnCrtThrdModalOptions}
                    // infoPopoverOptions={infoPopoverOptions}
                  />
                      </CardBody>
                    </Card>
                    </Col>
                  </Row>
                  <Row className="">
                    <Col lg="12">
{/* <ToolkitProvider keyField="_id" columns={columns} data={filteredNotifications} search> */}
  {/* {(props) => ( */}

          {/* <BootstrapTable
            // key={this.state.searchText}
            // {...props.baseProps}
            // {...paginationTableProps}
            // selectRow={selectRow}
            defaultSorted={defaultSorted}
            classes={"table align-middle table-nowrap"}
            headerClasses="header-class is-sticky-hdr"
            // id="tableScroll"
            // cellEdit={cellEditFactory({
            //   mode: "click",
            //   blurToSave: true,
            //   afterSaveCell: this.afterSaveCell,
            // })}
            bordered={true}
            // filter={filterFactory()}
            // noDataIndication={this.indication}
            responsive
          /> */}
  {/* // )} */}
{/* // </ToolkitProvider> */}
                      <Card>
                        <CardBody className="cardBodySticky">
        <Table className='table  mt-4 ms-0 me-0 mb-4'>
          <thead className='text-center'>
            <tr>
              <th>ID</th>
              <th>Message</th>
              <th>Send To</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredNotifications.map((notification, index) => {
              return (
                <tr key={index}>
                  <td>
                    {index + 1}
                  </td>
                  <td>
                    <h5
                      className="font-size-16 mb-1 notification-text"
                      dangerouslySetInnerHTML={{
                        __html: parseNotificationText(notification.textMsg),
                      }}
                    />
                  </td>
                  <td>
                    <div className="">
                      <h5 className="font-size-16 mb-1">
                        {users
                          .filter((user) => notification.sendToPerson && notification.sendToPerson.includes(String(user.bitrixID)))
                          .map((user) => `${user.fname} ${user.sname}`)
                          .join(", ")}
                      </h5>
                      <h5 className="font-size-16 mb-1">{notification.sendDynamically ? "Send Directly to User" : ""}</h5>
                      <h5 className="font-size-16 mb-1">{groupChats.find((chat) => chat.value === notification.sendToChat) ? groupChats.find((chat) => chat.value === notification.sendToChat).label : ""}</h5>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex gap-3">
                      <Link className="text-success" to="#">
                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" onClick={() => handleEditNotificationClick(notification)}></i>
                      </Link>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>                          
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Container>
              </div>
            </React.Fragment>
          </ReactDrawer>
        </div>
      )}
    </>
  );
};
